import React, { FC } from 'react';
import { CollectionType } from '../../data-layer/collections/service';
import { DataTestId } from '../../ui/layout/DataTestIdWrapper';
import { FlexProps } from '../../ui/layout/Flex';
import { Tab, Tabs } from '../../ui/navigation/Tabs';
import { Typography } from '../../ui/typography/Typography';
import { useIsMobileSync } from '../../utils/getIsMobile';
import { useTranslation } from '../../utils/useTranslation';

export interface UserCollectionsTabsProps extends FlexProps {
    collectionType: CollectionType;
    onChange: (value: CollectionType) => void;
}

export const UserCollectionsTabs: FC<UserCollectionsTabsProps> = ({
    collectionType,
    onChange,
    ...other
}) => {
    const t = useTranslation();

    const isMobile = useIsMobileSync();
    const isWideProfile = isMobile === false;

    return (
        <Tabs mb={2} mx={2} value={collectionType} onChange={onChange} {...other}>
            <Tab
                value="created"
                textDecoration="none"
                dataTestId={DataTestId.CREATED}
                width={isWideProfile ? 'auto' : '50%'}
                px={isWideProfile ? 2 : 1}
                py={isWideProfile ? 2 : 1}
            >
                <Typography
                    color="inherit"
                    textAlign="center"
                    textTransform={isWideProfile ? 'uppercase' : 'none'}
                    variant={isWideProfile ? 'caption' : 'body'}
                    weight={isWideProfile ? 'bold' : 'medium'}
                    letterSpacing={isWideProfile ? '0.7px' : 'normal'}
                >
                    {t('Созданные')}
                </Typography>
            </Tab>
            <Tab
                value="saved"
                textDecoration="none"
                dataTestId={DataTestId.SAVED}
                width={isWideProfile ? 'auto' : '50%'}
                px={isWideProfile ? 2 : 1}
                py={isWideProfile ? 2 : 1}
            >
                <Typography
                    color="inherit"
                    textAlign="center"
                    textTransform={isWideProfile ? 'uppercase' : 'none'}
                    variant={isWideProfile ? 'caption' : 'body'}
                    weight={isWideProfile ? 'bold' : 'medium'}
                    letterSpacing={isWideProfile ? '0.7px' : 'normal'}
                >
                    {t('Сохранённые')}
                </Typography>
            </Tab>
        </Tabs>
    );
};
